import template from './exploreTrendWidgetHeader.html';

export class ExploreTrendWidgetHeaderController {
    constructor() {
      this.title = this.titledynamic || this.title;
      this.subtitle = this.subtitledynamic || this.subtitle;
      this.icon = this.icondynamic || this.icon;
    }
}

export let ExploreTrendWidgetHeaderComponent = {
    template: () => { return template },
    controller: ExploreTrendWidgetHeaderController,
    controllerAs: 'vm',
    bindings: {
        title: "@",
        titledynamic: "=",
        subtitle: "@",
        subtitledynamic: "=",
        icon: "@",
        icondynamic: "="
    }
};

export default angular.module('app.components.explore.widgets.trendwrapper', [])
  .component('exploreTrendWidgetHeader',  ExploreTrendWidgetHeaderComponent);


/** WEBPACK FOOTER **
 ** ./src/components/explore/widgets/exploreTrendWidgetHeader.js
 **/